<template>
    <el-dialog  v-model="agreeShow"
        width="400px"
        align-center
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape=" false">
        <template #header>
            <div class="dialog_header flexMainXYcenter justify-between">
                <div class="flexMainXYcenter">
                    <img class="prompt_icon flexShrink" src="@/assets/images/layout/prompt_icon.png" alt="">
                    <div class="tit" >提示</div>
                </div>
                <!-- @click="closeDialog" -->
                <img class="close_icon" @click.stop="agreeShow = false" src="@/assets/images/layout/close_icon.png" alt="">
            </div>
        </template>
        <div class="dialog_body">
            <div class="dialog_msg_login">请先同意<el-link class="link_btn" :href="currentUrl + '#/privacyPage/agreement'" target="_blank" :underline="false">《用户协议》</el-link>和<el-link class="link_btn" target="_blank" :href="currentUrl + '#/privacyPage/privacy'" :underline="false">《隐私协议》</el-link></div>
        </div>
        <template #footer>
        <div class="dialog-footer">
            <el-button class="btn_style normal_btn" @click.stop="agreeShow = false">取消</el-button>
            <el-button type="primary" class="btn_style beauty_btn" style="margin-left: 12px;" @click.stop="agreeHandle">同意</el-button>
        </div>
        </template>
  </el-dialog>
</template>

<script setup>
    import { ref } from 'vue'
    import { messageError } from '@/utils/message';
    const currentUrl = window.location.origin + window.location.pathname
    const agreeShow = ref(false)

    const emits = defineEmits(['canLogin'])
    function agreeHandle(){
        agreeShow.value = false;
        emits('canLogin')
    }
    defineExpose({
        agreeShow
    })
</script>

<style lang="scss" scoped>
    
</style>